<div #heatmap>
    <div class="eia-heatmap-container">

        <!-- dynamically created from a json -->
        <div class="eia-heatmap-title" >Daily regional average temperatures and departure from normal </div>
        <div class="eia-heatmap-subtitle">degrees Fahrenheit</div>
        <div>
            <div class="eia-heatrow">
                <div class="eia-heatrow-title"></div>
                <div class="eia-heatrow-data" *ngFor="let label of heatMapTopLabels">{{label}}</div>

            </div>
        </div>

       <!-- begin heatmap data -->
        <div *ngFor="let region of heatMapData">
            <div class="eia-heatrow">
                <div class="eia-heatrow-title">{{region.name}}</div>
                <div *ngFor="let data of region.data" class="eia-heatrow-data" [ngStyle]="
                    {'background-color':data ? getHeatmapDataColor(data.departure): null, 'color': getHeatmapTextColor(data.departure)}" >
                    <div [ngClass]="{'eia-heatmap-forecast':data && data.isForecast == 1}">{{data.actual}}</div>
                </div>
            </div>

        </div>

        <!-- end heatmap data -->

        <div class="eia-heatmap-med-spacer"></div>

        <!-- begin legend -->
        <app-map-legend [heatMapColors]="heatMapColors"></app-map-legend>
        <!-- end legend -->

    </div>
</div>





// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/display-eia-heatmap/display-eia-heatmap.component.html